import { FormErrors } from 'redux-form';
import { chargesToArray, rutValidator } from './utils';

const regexString = /^[A-Za-zÀ-ÿÑñ\-' ]+$/i;
const regexDate = /^((0?[1-9]|[12][0-9]|3[01])[- /.](0?[1-9]|1[012])[- /.](19|20)?[0-9]{2})*$/i;

export default (values: any) => {
  const errors: FormErrors<any> = {};
  const chargesCount = values.charges ? chargesToArray(values.charges) : [0];
  const totalCharges = values.charges ? values.charges : 1;
  let totalPercentage: number = 0;

  if (!values.legalHeirs) {
    chargesCount.map(index => {
      if (!values[`charge-documentNumber-${index}`]) {
        errors[`charge-documentNumber-${index}`] = 'Campo obligatorio';
      } else if (!rutValidator(values[`charge-documentNumber-${index}`])) {
        errors[`charge-documentNumber-${index}`] = 'Rut inválido';
      }

      if (!values[`charge-name-${index}`]) {
        errors[`charge-name-${index}`] = 'Campo obligatorio';
      } else if (!regexString.test(values[`charge-name-${index}`])) {
        errors[`charge-name-${index}`] =
          'El nombre no puede contener números ni caracteres especiales, solo letras';
      } else if (values[`charge-name-${index}`].length > 100) {
        errors[`charge-name-${index}`] =
          'El nombre solo puede contener un máximo de 100 caracteres';
      }

      if (!values[`charge-percentage-${index}`]) {
        errors[`charge-percentage-${index}`] = 'Campo Obligatorio';
      } else {
        totalPercentage += parseFloat(values[`charge-percentage-${index}`]);
      }

      if (!values[`charge-relationship-${index}`]) {
        errors[`charge-relationship-${index}`] = 'Campo Obligatorio';
      }

      if (!values[`charge-birthdate-${index}`]) {
        errors[`charge-birthdate-${index}`] = 'Campo obligatorio';
      } else if (!regexDate.test(values[`charge-birthdate-${index}`])) {
        errors[`charge-birthdate-${index}`] =
          'Formato de fecha inválido, el formato es dd-mm-aaaa';
      }

      return 0;
    });

    if (totalPercentage !== 100) {
      for (let i = 1; i <= totalCharges; i += 1) {
        if (!errors[`charge-percentage-${i}`]) {
          errors[`charge-percentage-${i}`] =
            'Suma de los porcentajes debe ser siempre igual a 100';
        }
      }
    }
  }

  return errors;
};
